export default "__VITE_ASSET__DNMeEqux__"